<app-header></app-header>
<div class="resumo-toolbar">
  <a class="voltar-demanda" [routerLink]="['/demanda-exibir', codigo]"><span class="mdi mdi-arrow-left" aria-hidden="true"></span> Voltar à demanda</a>
  <span class="toolbar-legenda">Visão consolidada do atendimento</span>
</div>
<div *ngIf="carregando" class="estado-resumo" role="status"><span class="mdi mdi-time" aria-hidden="true"></span> Carregando resumo da demanda...</div>
<div *ngIf="erro" class="alert alert-danger" role="alert">
  {{ erro }}
  <button type="button" class="btn btn-default btn-sm" (click)="carregar()">Tentar novamente</button>
</div>

<main *ngIf="resumo" class="resumo-demanda">
  <header class="resumo-cabecalho">
    <div class="cabecalho-principal">
      <span class="sobretitulo">DEMANDA #{{ resumo.demanda.numero || resumo.demanda.codigo_demanda }}</span>
      <h1>{{ resumo.demanda.assunto || 'Assunto não informado' }}</h1>
      <div class="cabecalho-etiquetas">
        <span class="etiqueta etiqueta-situacao"><span class="ponto-situacao" aria-hidden="true"></span>{{ resumo.demanda.demandasituacao?.nome || 'Situação não informada' }}</span>
        <span class="etiqueta etiqueta-tipo">{{ resumo.demanda.demandatipo?.nome || 'Tipo não informado' }}</span>
        <span *ngIf="resumo.demanda.prioridade" class="etiqueta etiqueta-prioridade">Prioridade: {{ resumo.demanda.prioridade }}</span>
      </div>
    </div>
    <dl class="cabecalho-contadores">
      <div><dt>Registros</dt><dd>{{ resumo.historico.length + 1 }}</dd></div>
      <div><dt>Arquivos</dt><dd>{{ resumo.anexos.length }}</dd></div>
    </dl>
  </header>

  <div class="resumo-visao-geral">
    <section class="resumo-card" aria-labelledby="titulo-participantes">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-accounts" aria-hidden="true"></span><div><h2 id="titulo-participantes">Participantes</h2><p>Quem solicita e quem acompanha</p></div></div>
      <dl class="dados-demanda">
        <div><dt>Solicitante</dt><dd>{{ resumo.demanda.demandante?.nome || 'Não informado' }}</dd></div>
        <div><dt>Responsável atual</dt><dd>{{ resumo.demanda.colaborador?.nome || 'Não atribuído' }}</dd></div>
      </dl>
      <a *ngIf="resumo.demanda.codigo_demandante" class="link-cadastro" [routerLink]="['/associado-resumo', resumo.demanda.codigo_demandante]">Visualizar cadastro <span class="mdi mdi-arrow-right" aria-hidden="true"></span></a>
    </section>
    <section class="resumo-card" aria-labelledby="titulo-datas">
      <div class="secao-titulo"><span class="secao-icone mdi mdi-calendar" aria-hidden="true"></span><div><h2 id="titulo-datas">Datas do atendimento</h2><p>Abertura e última atualização</p></div></div>
      <dl class="dados-demanda">
        <div><dt>Abertura</dt><dd>{{ (resumo.demanda.created_at | date: 'dd/MM/yyyy') || 'Não informada' }} <span class="hora">{{ resumo.demanda.created_at | date: 'HH:mm' }}</span></dd></div>
        <div><dt>Atualização do cadastro</dt><dd>{{ (resumo.demanda.updated_at | date: 'dd/MM/yyyy') || 'Não informada' }} <span class="hora">{{ resumo.demanda.updated_at | date: 'HH:mm' }}</span></dd></div>
      </dl>
    </section>
  </div>

  <section class="resumo-card secao-descricao" aria-labelledby="titulo-solicitacao">
    <div class="secao-titulo"><span class="secao-icone mdi mdi-file-text" aria-hidden="true"></span><div><h2 id="titulo-solicitacao">Solicitação inicial</h2><p>O motivo da abertura da demanda</p></div></div>
    <div class="conteudo descricao-inicial" [innerHTML]="resumo.demanda.descricao || 'Descrição não informada.'"></div>
  </section>

  <section class="resumo-card" aria-labelledby="titulo-historico">
    <div class="secao-titulo"><span class="secao-icone mdi mdi-time-restore" aria-hidden="true"></span><div><h2 id="titulo-historico">Histórico de atendimento <span class="contagem">{{ resumo.historico.length + 1 }}</span></h2><p>Acompanhe a evolução da demanda</p></div></div>
    <ol class="historico">
      <li class="registro-abertura">
        <div class="registro-cabecalho"><h3>Abertura da demanda</h3><time>{{ resumo.demanda.created_at | date: 'dd/MM/yyyy HH:mm' }}</time></div>
        <p class="registro-autor">{{ resumo.demanda.demandante?.nome || 'Autor não informado' }}</p>
        <p class="registro-legenda">Solicitação registrada para atendimento.</p>
      </li>
      <li *ngFor="let passo of resumo.historico; let i = index">
        <div class="registro-cabecalho"><h3>Registro de atendimento <span class="registro-numero">{{ i + 1 }}</span></h3><time>{{ passo.created_at | date: 'dd/MM/yyyy HH:mm' }}</time></div>
        <p class="registro-autor">{{ passo.colaborador?.nome || passo.demandante?.nome || 'Autor não informado' }}</p>
        <dl class="registro-classificacao">
          <div><dt>Tipo</dt><dd>{{ passo.demandatipo?.nome || 'Não informado' }}</dd></div>
          <div><dt>Situação</dt><dd>{{ passo.demandasituacao?.nome || 'Não informada' }}</dd></div>
        </dl>
        <div class="conteudo" [innerHTML]="passo.descricao || 'Sem descrição.'"></div>
      </li>
    </ol>
    <p *ngIf="resumo.historico.length === 0" class="estado-vazio">As próximas movimentações aparecerão aqui. Ainda não há registros após a abertura.</p>
  </section>

  <section class="resumo-card" aria-labelledby="titulo-arquivos">
    <div class="secao-titulo"><span class="secao-icone mdi mdi-attachment-alt" aria-hidden="true"></span><div><h2 id="titulo-arquivos">Arquivos e documentos <span class="contagem">{{ resumo.anexos.length }}</span></h2><p>Anexos da solicitação e dos registros de atendimento</p></div></div>
    <div *ngIf="erroDownload" class="alert alert-danger" role="alert">{{ erroDownload }}</div>
    <p *ngIf="resumo.anexos.length === 0" class="estado-vazio">Nenhum arquivo foi anexado a esta demanda.</p>
    <ul class="lista-arquivos" *ngIf="resumo.anexos.length > 0">
      <li *ngFor="let anexo of resumo.anexos" class="arquivo">
        <span class="arquivo-icone mdi mdi-file-text" aria-hidden="true"></span>
        <div class="arquivo-dados">
          <h3>{{ anexo.nome }}</h3>
          <p>{{ anexo.colaborador?.nome || 'Autor não informado' }} <span aria-hidden="true">·</span> {{ anexo.created_at | date: 'dd/MM/yyyy HH:mm' }}</p>
          <span class="arquivo-vinculo">{{ anexo.codigo_demanda === resumo.demanda.codigo_demanda ? 'Demanda principal' : 'Registro #' + anexo.codigo_demanda }}</span>
        </div>
        <div class="arquivo-acoes">
          <button type="button" class="btn btn-primary btn-sm" *ngIf="visualizador.podeVisualizar(anexo.nome)" (click)="visualizador.abrir(codigo, anexo.codigo_demanda_anexo, anexo.nome)" [attr.aria-label]="'Visualizar ' + anexo.nome"><span class="mdi mdi-eye" aria-hidden="true"></span> Visualizar</button>
          <button type="button" class="btn btn-default btn-sm" [disabled]="baixando[anexo.codigo_demanda_anexo]" (click)="baixar(anexo)" [attr.aria-label]="'Baixar ' + anexo.nome"><span class="mdi mdi-download" aria-hidden="true"></span> {{ baixando[anexo.codigo_demanda_anexo] ? 'Baixando...' : 'Baixar original' }}</button>
        </div>
      </li>
    </ul>
  </section>
</main>
<app-footer></app-footer>
<app-demanda-anexo-visualizar #visualizador></app-demanda-anexo-visualizar>
